import { render, staticRenderFns } from "./TipoObrasListagem.vue?vue&type=template&id=6c30a4da&scoped=true&"
import script from "./TipoObrasListagem.vue?vue&type=script&lang=js&"
export * from "./TipoObrasListagem.vue?vue&type=script&lang=js&"
import style0 from "./TipoObrasListagem.vue?vue&type=style&index=0&id=6c30a4da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c30a4da",
  null
  
)

export default component.exports